import React from 'react'
import { makeStyles } from '@material-ui/core'
import { connect } from 'react-redux'

import { roles } from '../utils/constants'
import { useHistory } from 'react-router-dom'
import StyledSVG from '../components/shared/StyledSVG'
import EventCalendar from '../components/calendar/EventCalendar'
import SocioemotionalSlider from '../components/slider/SocioemotionalSlider'
import InfirmarySlider from '../components/slider/InfirmarySlider'
import EventCommentSlider from '../components/slider/EventCommentSlider'
import EventsSlider from '../components/slider/EventsSlider'
import LastMessagesSlider from '../components/slider/LastMessagesSlider'
import Button from '../components/button/Button'

import { getHomepageOverviewRSPA } from '../store/users/actions'
import { newGetThemes, newCleanThemes } from '../store/themes/actions'
import { getReportStudentsAnswers } from '../store/reports/actions'
import {
  getEvents,
  getEventComments,
  getEventsRSPA
} from '../store/events/actions'
import { getMessagesWithoutRoomRSPA } from '../store/chats/actions'

import childrensImageVetor from '../assets/homepage-introdution-vector.png'
import homepageAnnouncementsSVG from '../assets/icons/homepage-announcements.svg'
import homepageReportsSVG from '../assets/icons/homepage-reports.svg'
import homepageContentsSVG from '../assets/icons/homepage-contents.svg'
import homepageClassroomsSVG from '../assets/icons/homepage-classrooms.svg'
import homepageEventsSVG from '../assets/icons/homepage-events.svg'
import homepageMessagesSVG from '../assets/icons/homepage-messages.svg'

const useStyles = makeStyles(theme => ({
  root: {
    width: '97%',
    height: '100%',
    fontFamily: 'Montserrat, Source Sans Pro',
    paddingBottom: 50
  },
  first_section: {
    width: '100%',
    minHeight: 270,
    backgroundColor: '#E8E8DB',
    borderRadius: 16,
    display: 'flex',
    backgroundImage: `url(${childrensImageVetor})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    padding: '38px 76px'
  },
  socioemotional_section_wrapper: {
    // width: '100%',
  },
  socioemotional_btn: {
    backgroundColor: '#EF7B8E',
    width: 360,
    height: 40,
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7B8E'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: '19.5px'
  },
  text_section: {
    maxWidth: '30%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& .title': {
      margin: 0,
      color: '#4D5E80',
      marginBottom: 16
    },
    '& .subtitle': {
      margin: 0,
      color: '#666666',
      marginBottom: 32
    }
  },
  options_wrapper: {
    width: '100%',
    height: '100%',
    minHeight: 480,
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 16
  },
  option: {
    width: 290,
    height: 210,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    padding: '16px 24px',
    borderRadius: 16,
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 10px 18px -3px rgba(0,0,0,0.2)',
      transform: 'translateY(-5px)'
    }
  },
  option_text: {
    display: 'flex',
    flexDirection: 'column',
    '& .title': {
      fontWeight: 500,
      fontSize: 20,
      margin: 0
    },
    '& .count': {
      fontWeight: 600,
      fontSize: 40,
      margin: 0
    },
    '& .plus': {
      margin: 0
    }
  },
  white: {
    '& .title, .count, .plus': {
      color: '#FFFFFF'
    }
  },
  dark: {
    '& .title, .count, .plus': {
      color: '#555555'
    }
  },
  main_content_wrapper: {
    display: 'flex',
    marginTop: 24,
    alignItems: 'flex-start',
    columnGap: 32,
    [theme.breakpoints.down('1000')]: {
      flexDirection: 'column'
    }
  },
  first_column: {
    width: '60%',
    height: '100%',
    minHeight: 480,
    [theme.breakpoints.down('1000')]: {
      overflow: 'auto',
      width: '100%'
    }
  },
  second_column: {
    height: '100%',
    width: '40%',
    minHeight: 480,
    [theme.breakpoints.down('1000')]: {
      width: '100%',
      marginTop: 20
    }
  }
}))

const HomePage = ({
  getThemes,
  getEvents,
  getEventsRSPA,
  getMessagesWithoutRoomRSPA,
  getHomepageOverviewRSPA,
  getEventComments,
  eventComments,
  cleanThemes,
  events,
  themes,
  getReportStudentsAnswers,
  reportAnswers,
  user,
  currentOccupation,
  fractalId,
  userId
}) => {
  // only school admin can access the homepage
  const isAdmin = currentOccupation?.includes(roles.SCHOOL_ADMIN)
  const isTeacher = currentOccupation?.includes(roles.TEACHER)
  const classes = useStyles()
  const history = useHistory()
  const [options, setOptions] = React.useState([
    {
      key: 'active_classrooms',
      label: 'Turmas ativas',
      svg: homepageClassroomsSVG,
      backgroundColor: '#9DD2DA',
      fontTheme: 'dark'
    },
    {
      key: 'contents',
      label: 'Conteúdos disponíveis',
      svg: homepageContentsSVG,
      backgroundColor: '#8B598E',
      fontTheme: 'white'
    },
    {
      key: 'created_events',
      label: 'Comunicados criados',
      svg: homepageAnnouncementsSVG,
      backgroundColor: '#F4A87C',
      fontTheme: 'white'
    },
    {
      key: 'received_messages',
      label: 'Total de mensagens',
      svg: homepageMessagesSVG,
      backgroundColor: '#386093',
      fontTheme: 'white'
    },
    {
      key: 'total_events',
      label: 'Total de eventos',
      svg: homepageEventsSVG,
      backgroundColor: '#D2D5D8',
      fontTheme: 'dark'
    },
    {
      key: 'created_reports',
      label: 'Diários gerados',
      svg: homepageReportsSVG,
      backgroundColor: '#555555',
      fontTheme: 'white'
    }
  ])

  React.useEffect(() => {
    getHomepageOverviewRSPA().then(res => {
      setOptions(prev => {
        const updateOptions = prev.map(option => {
          if (option.key === 'received_messages') {
            Object.assign(option, { plusInfo: res?.pending_messages })
          }
          return {
            ...option,
            totalCount: res?.[option?.key]
          }
        })
        return updateOptions
      })
    })
  }, [])

  const handleSocioemotionalBtn = () => {
    history.push('/socioemotional')
  }

  return (
    <div className={classes.root}>
      <div className={classes.first_section}>
        <div className={classes.text_section}>
          <h1 className='title'>Bem-vindo(a) {user?.attributes?.name}</h1>
          <p className='subtitle'>
            Transforme emoções em competências, engaje as famílias, fortaleça a
            cultura e a performance acadêmica de sua escola.
          </p>
          <Button
            onClick={handleSocioemotionalBtn}
            className={classes.socioemotional_btn}
          >
            Explorar os conteúdos do Versar
          </Button>
        </div>
      </div>
      <div className={classes.socioemotional_section_wrapper}>
        <SocioemotionalSlider
          history={history}
          getThemes={getThemes}
          themes={themes}
          cleanThemes={cleanThemes}
        />
      </div>
      <div className={classes.main_content_wrapper}>
        <div className={classes.first_column}>
          <div className={classes.options_wrapper}>
            {options.map((option, idx) => {
              return (
                <div
                  key={idx}
                  className={classes.option}
                  style={{ backgroundColor: option.backgroundColor }}
                >
                  <StyledSVG src={option.svg} width={48} height={48} />
                  <div
                    className={`${classes.option_text} ${
                      classes?.[option.fontTheme]
                    }`}
                  >
                    <p className='title'>{option.label}</p>
                    <h1 className='count'>{option.totalCount}</h1>
                    {option.plusInfo > 0 && (
                      <p className='plus'>{option.plusInfo} sem ler</p>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
          <EventCommentSlider
            history={history}
            getEventComments={getEventComments}
            eventComments={eventComments}
          />
          <EventsSlider
            getEventsRSPA={getEventsRSPA}
            history={history}
            isAdmin={isAdmin}
          />
        </div>
        <div className={classes.second_column}>
          <InfirmarySlider
            isTeacher={isTeacher}
            userId={userId}
            history={history}
            reportAnswers={reportAnswers}
            getReportStudentsAnswers={getReportStudentsAnswers}
          />
          <LastMessagesSlider
            currentOccupation={currentOccupation}
            fractalId={fractalId}
            history={history}
            getMessagesWithoutRoomRSPA={getMessagesWithoutRoomRSPA}
          />
        </div>
      </div>
      <div className={''}>
        <EventCalendar
          isAdmin={isAdmin}
          history={history}
          getEvents={getEvents}
          events={events}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    events: state.events,
    themes: state.themes,
    reportAnswers: state.reports.reportAnswers,
    eventComments: state.events.comments,
    user: state.auth.user.data,
    userId: state.auth.user.data.id,
    currentOccupation: state.auth.currentOccupation,
    fractalId: state.auth?.user?.data?.attributes?.fractal_id
  }
}

const mapDispatchToProps = dispatch => ({
  getEvents: data => dispatch(getEvents(data)),
  getEventComments: data => dispatch(getEventComments(data)),
  getThemes: data => dispatch(newGetThemes(data)),
  cleanThemes: data => dispatch(newCleanThemes(data)),
  getReportStudentsAnswers: data => dispatch(getReportStudentsAnswers(data)),
  getEventsRSPA: data => dispatch(getEventsRSPA.request(data)),
  getMessagesWithoutRoomRSPA: data =>
    dispatch(getMessagesWithoutRoomRSPA.request(data)),
  getHomepageOverviewRSPA: data =>
    dispatch(getHomepageOverviewRSPA.request(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)
